<template>
  <div class="px-3">
    <LoadingMore v-if="loading"></LoadingMore>
    <div v-else-if="data">
      <!-- <div v-if="authType !== 'Patient'">
        <a class="svg svg-sm svg-upper text-primary pointer" @click.prevent="sendQuestion(data.question.text)">
          <SendIcon></SendIcon>
          {{ $t("next_question") }}
        </a>
        <p>
          {{ data.question.text }}
        </p>
      </div> -->
      <div
        v-for="condition in data.conditions"
        :key="condition.id"
        class="border-bottom mb-3"
      >
        <strong class="d-block mb-1">
          {{ condition.name[authLocale] }}
          <span
            v-if="
              condition.name[authLocale] != condition.common_name[authLocale]
            "
          >
            ({{ condition.common_name[authLocale] }})
          </span>
          <small v-if="condition.extras && condition.extras.icd10_code">
            {{ condition.extras.icd10_code }}
          </small>
          - {{ Math.round(condition.probability * 100) }}%
          <div class="progress">
            <div
              class="progress-bar"
              :class="{
                'bg-success': condition.probability <= 0.33,
                'bg-warning':
                  condition.probability > 0.33 && condition.probability <= 0.67,
                'bg-danger': condition.probability >= 0.67,
              }"
              :style="{ width: `${condition.probability * 100}%` }"
            ></div>
          </div>
        </strong>
        <ul>
          <li>{{ $t(`prevalence_${condition.prevalence}`) }}</li>
          <li>{{ $t(`acuteness_${condition.acuteness}`) }}</li>
          <li>{{ $t(`severity_${condition.severity}`) }}</li>
          <li>{{ $t(`triage_${condition.triage_level}`) }}</li>
        </ul>
        <p v-if="condition.extras && condition.extras.hint">
          {{ condition.extras.hint[authLocale] }}
        </p>
      </div>
    </div>
    <div v-else class="alert alert-warning text-center">
      {{ $t("not_found") }}
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingMore from '@/components/Loadings/More'
// import SendIcon from '@/components/Icons/Send'
export default {
  components: {
    LoadingMore
    // SendIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      data: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      caseById: 'pcase/byId',
      authType: 'auth/type'
    }),
    pcase () {
      return this.caseById(this.value)
    }
  },
  watch: {
    pcase: {
      deep: true,
      handler (val) {
        this.fetchInfermedica(this.value)
      }
    },
    value (val) {
      this.fetchInfermedica(val)
    }
  },
  mounted () {
    this.fetchInfermedica(this.value)
  },
  methods: {
    ...mapActions({
      sendMessage: 'chat/send'
    }),
    async sendQuestion (msg) {
      this.sendMessage({ id: this.$route.params.id, msg: msg })
    },
    async fetchInfermedica (caseId) {
      this.loading = true
      try {
        const response = await this.axios.get(
          `/api/patient-cases/${caseId}/infermedica`
        )
        const v = response.data.data
        if (v) {
          this.data = v
        } else {
          this.data = null
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.setError(err)
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
      "probableConditions": "სავარაუდო დაავადებები",
      "hint": "რჩევა",
      "prevalence_very_rare": "აღნიშნული დაავადების პრევალენტურობა ძალიან იშვიათია.",
      "prevalence_rare": "აღნიშნული დაავადების პრევალენტურობა იშვიათია.",
      "prevalence_moderate": "აღნიშნული დაავადების პრევალენტურობა საშუალო სიხშირისაა.",
      "prevalence_common": "აღნიშნული დაავადების პრევალენტურობა ხშირია.",
      "acuteness_chronic": "მიეკუთვნება ქრონიკულ დაავადებებს.",
      "acuteness_chronic_with_exacerbations": "მიეკუთვნება ქრონიკულ დაავადებებს პერიოდული გამწვავებებით.",
      "acuteness_acute_potentially_chronic": "მიეკუთვნება მწვავე დაავადებებს, შესაძლებელია მიიღოს ქრონიკული ხასიათი.",
      "acuteness_acute": "მიეკუთვნება მწვავე დაავადებებს.",
      "severity_mild": "ხასიათდება ნაკლები სიმძიმით.",
      "severity_moderate": "ხასიათდება საშუალო სიმძიმით.",
      "severity_severe": "ხასიათდება მძიმე მიმდინარეობით.",
      "triage_emergency": "საჭიროებს გადაუდებელ სამედიცინო მომსახურებას.",
      "triage_consultation": "საჭიროებს ექიმის კონსულტაციას.",
      "triage_self_care": "დასაშვებია თვითმკურნალობა.",
      "not_found": "არასაკმარისი მონაცემი",
      "next_question": "შემდეგი შეკითხვა"
  },
  "en": {
      "probableConditions": "Probable Conditions",
      "hint": "Hint",
      "prevalence_very_rare": "Prevalence of given condition is very rare.",
      "prevalence_rare": "Prevalence of given condition is rare.",
      "prevalence_moderate": "Prevalence of given condition is moderate.",
      "prevalence_common": "Prevalence of given condition is common.",
      "acuteness_chronic": "The condition is chronic.",
      "acuteness_chronic_with_exacerbations": "The condition is chronic with exacerbations.",
      "acuteness_acute_potentially_chronic": "The condition is acute and potentially chronic.",
      "acuteness_acute": "The condition is acute.",
      "severity_mild": "It's severity is mild.",
      "severity_moderate": "It's severity is moderate.",
      "severity_severe": "It's severity is severe.",
      "triage_emergency": "Requires emergency service.",
      "triage_consultation": "Requires consultation with specialist.",
      "triage_self_care": "Can be self treated.",
      "not_found": "Not enough data",
      "next_question": "Next Question"
  }
}
</i18n>
